import React from 'react'
import ReactSVG from 'react-svg'

import Loading from '../../../../../images/neon/loading.svg'
import { useStyles } from './onboarding-setup-loading.styles'

const OnboardingSetupLoading = () => {
  const styles = useStyles()

  return (
    <div className={styles.loadingContentContainer}>
      <div className={styles.title}>
        Loading the good stuff
      </div>
      <div className={styles.subTitle}>
        You&apos;ll be able to start watching right away
      </div>
      <div className={styles.loadingContainer}>
        <ReactSVG src={Loading} />
      </div>
    </div>
  )
}

export default OnboardingSetupLoading
